/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/ActionsHubManager", "../FluxCommon/Store", "./SelectionActions"], function (require, exports, ActionsHubManager_1, Store_1, SelectionActions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SelectionStore = /** @class */ (function (_super) {
        __extends(SelectionStore, _super);
        function SelectionStore() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._select = function (payload) {
                _this._state.selectedItem = payload.item;
                _this._state.showSelectedItem = payload.showSelectedItem;
                _this._state.selectedItemType = payload.selectedItemType;
                _this._state.itemUID = payload.itemUID;
                _this._state.properties = payload.properties;
                _this.emitChanged();
            };
            return _this;
        }
        SelectionStore.getKey = function () {
            return "kubernetes-selection-store";
        };
        SelectionStore.prototype.initialize = function (instanceId) {
            _super.prototype.initialize.call(this, instanceId);
            this._state = { selectedItem: undefined, showSelectedItem: false, selectedItemType: "", itemUID: "" };
            this._actions = ActionsHubManager_1.ActionsHubManager.GetActionsHub(SelectionActions_1.SelectionActions);
            this._actions.selectItem.addListener(this._select);
        };
        SelectionStore.prototype.disposeInternal = function () {
            this._actions.selectItem.removeListener(this._select);
        };
        SelectionStore.prototype.getState = function () {
            return this._state;
        };
        return SelectionStore;
    }(Store_1.StoreBase));
    exports.SelectionStore = SelectionStore;
});
